import { RefiHttpClient } from '@cof/refi-web-sdk';
import { REFI_PERSONAL_CONST } from '../../../shared/constants/app.constants.js';
import { DebugService } from '../../../shared/services/debug.service.js';
import { SessionService } from '../session/session.service.js';

class _ApiService {
  constructor() {
    this._client = new RefiHttpClient().withRetry(3);
    this.debug = new DebugService('ApiService');
    this.headers = REFI_PERSONAL_CONST.HTTP_HEADERS;
    this.fetchWrapper = (url, opts, timeout = 0) => {
      this.debug.log(
        `${timeout <= 0 ? 'Not' : ''} using custom timeout${
          timeout > 0 ? ` of ${timeout}ms` : ''
        } for url ${url}`
      );
      return timeout > 0
        ? this._client.withCustomTimeout(this._client.fetch(url, opts), timeout)
        : this._client.fetch(url, opts);
    };
  }

  async get(url, opts = {}, timeout = 0) {
    const headers = this.buildHeaders();
    return this.fetchWrapper(
      url,
      {
        headers,
        withCredentials: true,
        ...opts,
      },
      timeout
    ).then(this.constructor._httpInterceptor);
  }

  async post(url, body, opts = {}, timeout = 0) {
    const headers = this.buildHeaders();
    const options = {
      ...opts,
      headers,
      withCredentials: true,
      method: 'POST',
      body: JSON.stringify(body),
    };
    return this.fetchWrapper(url, options, timeout).then(
      this.constructor._httpInterceptor
    );
  }

  async patch(url, body, opts = {}, timeout) {
    const headers = this.buildHeaders();
    const options = {
      ...opts,
      headers,
      withCredentials: true,
      method: 'PATCH',
      body: JSON.stringify(body),
    };
    return this.fetchWrapper(url, options, timeout).then(
      this.constructor._httpInterceptor
    );
  }

  static _httpInterceptor(res) {
    if (res.status === 204) {
      return res;
    }
    if (res.status >= 200 && res.status < 300) {
      return res.json();
    }
    if (res.status === 403 || res.status === 401) {
      document.dispatchEvent(
        new CustomEvent('host-app-event', {
          bubbles: true,
          composed: true,
          detail: {
            actionName: 'logout',
            data: {},
          },
        })
      );
      window.open('/login', '_self');
    }
    return Promise.reject(res);
  }

  buildHeaders() {
    if (REFI_PERSONAL_CONST.isDevEnv()) {
      this.headers['x-upstream-env'] = 'dev';
    } else if (REFI_PERSONAL_CONST.isSBEnv()) {
      this.headers['x-upstream-env'] = 'sb';
    } else {
      delete this.headers['x-upstream-env'];
    }

    if (sessionStorage.getItem('C1-REFI-APPIDS')) {
      this.headers['C1-REFI-APPIDS'] = sessionStorage.getItem('C1-REFI-APPIDS');
    }

    if (SessionService.session?.eAppId) {
      this.headers.eapp_id = SessionService.session.eAppId;
    }

    return this.headers;
  }
}

export const ApiService = new _ApiService();
